import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { u as useThemeMode } from '../../theme/hooks/useThemeMode/useThemeMode-u5aJEVzi.js';
import { T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

/** The Table component to export */
const HtmlTable = /*#__PURE__*/styled('table').attrs(() => ({
  role: 'table',
  cellPadding: '0',
  cellSpacing: '0'
})).withConfig({
  componentId: "sc-storm-ui-40025937__sc-trhq1c-0"
})(["display:table;width:initial;border-collapse:collapse;background-color:", ";line-height:19px;> thead > tr > td,> thead > tr > th,> tbody > tr > th{color:", ";font:", ";font-weight:", ";text-align:start;vertical-align:top;border-top:", ";border-bottom:", ";padding:", ";", "}> tbody > tr > td{color:", ";font:", ";text-align:start;vertical-align:middle;border-top:", ";border-bottom:", ";padding:", ";", "}> tfoot > tr > td{color:", ";font:", ";font-weight:", ";text-align:start;border-top:", ";border-bottom:", ";padding:", ";", "}"], ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.font.weight.bold, ({
  theme
}) => theme.table.cell.border.header.default, ({
  theme
}) => theme.table.cell.border.header.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)), ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.table.cell.border.body.default, ({
  theme
}) => theme.table.cell.border.body.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)), ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.font.weight.bold, ({
  theme
}) => theme.table.cell.border.header.default, ({
  theme
}) => theme.table.cell.border.header.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
const Table = ({
  taktId,
  taktValue,
  ...props
}) => {
  const {
    themeMode
  } = useThemeMode();
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('table')
  }, /*#__PURE__*/React__default.createElement(HtmlTable, _extends({
    key: themeMode
  }, props)));
};

export { Table as T };
//# sourceMappingURL=Table-D6vUrV9H.js.map
